var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LedgerModal',{staticClass:"ledger-sign-transaction",attrs:{"title":_vm.$t('ledger.modal.sign-transaction')}},[_c('LedgerModalNanoS'),_c('AeSpinner'),_c('ModalHeader',[_vm._v(" "+_vm._s(_vm.$t('ledger.modal.sign-transaction'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }